import comp from "./EvidenceCardV2";
export default comp;
